"use client";

import Link from "next/link";
import { useTranslations } from "next-intl";
import { PARTNER_SIGNUP_ENABLED } from "@/components/constants/general";

export default function ScrollToTop() {
  const t = useTranslations("header");

  return (
    // One row so the two buttons sit side by side and never overlap, however
    // narrow the screen gets.
    <div className="fixed bottom-20 md:bottom-8 right-5 z-[99] flex items-center gap-3">
      {/* Brand orange, but a gradient pill rather than a second flat circle —
          the icon sits in a translucent disc so it reads as its own mark next
          to the WhatsApp blob. */}
      {PARTNER_SIGNUP_ENABLED && (
        <Link
          href="/own-and-earn"
          aria-label={t("exploreOwnAndEarn")}
          // Below sm the label is hidden, so this becomes a plain circle sized to
          // match the WhatsApp button beside it; from sm up it is the pill again.
          className="group flex items-center justify-center sm:justify-start gap-0 sm:gap-2 h-16 w-16 sm:h-12 sm:w-auto px-0 sm:pl-2 sm:pr-5 text-sm font-semibold text-white rounded-full bg-gradient-to-r from-[#F26322] to-[#E14A1E] shadow-[0_4px_14px_rgba(242,99,34,0.45)] hover:shadow-[0_6px_20px_rgba(242,99,34,0.65)] hover:-translate-y-0.5 transition-all duration-300"
        >
          {/* The translucent disc only makes sense inside the pill — on the
              circle the icon stands on the orange itself, like WhatsApp's. */}
          <span className="flex items-center justify-center w-8 h-8 shrink-0 rounded-full sm:bg-white/20 transition-colors duration-300 sm:group-hover:bg-white/30">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2.2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="w-8 h-8 sm:w-4 sm:h-4 text-white"
              aria-hidden="true"
            >
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14 2 14 8 20 8" />
              <line x1="16" y1="13" x2="8" y2="13" />
              <line x1="16" y1="17" x2="8" y2="17" />
            </svg>
          </span>
          <span className="hidden sm:inline whitespace-nowrap">{t("exploreOwnAndEarn")}</span>
        </Link>
      )}

      <a
        href="https://wa.me/919270768020"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        className="flex items-center justify-center w-16 h-16 bg-[#25D366] rounded-full shadow-[0_4px_15px_rgba(37,211,102,0.4)] hover:shadow-[0_6px_20px_rgba(37,211,102,0.6)] hover:scale-110 transition-all duration-300"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="white"
          className="w-9 h-9"
        >
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
        </svg>
      </a>
    </div>
  );
}
